import React from "react";
import { HelpCircle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface AEOAnswerBlockProps {
  question: string;
  answer: string;
  className?: string;
  badge?: string;
  sourceLabel?: string;
}

/**
 * Answer Engine Optimization (AEO) Component (Phase 5 of Playbook)
 * 
 * Formats 40-60 word concise direct answers under H2 questions designed specifically for 
 * Google AI Overviews, ChatGPT, Gemini, and Perplexity extractability.
 */
export const AEOAnswerBlock: React.FC<AEOAnswerBlockProps> = ({
  question,
  answer,
  className,
  badge = "AI Answer Summary",
  sourceLabel = "Verified Official Info",
}) => {
  return (
    <div className={cn("my-6 rounded-2xl border border-accent/20 bg-accent/5 p-5 md:p-6 shadow-sm", className)}>
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2">
          <HelpCircle className="h-5 w-5 text-accent" />
          <span className="text-xs font-bold uppercase tracking-wider text-accent">{badge}</span>
        </div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <CheckCircle2 className="h-3.5 w-3.5 text-green-600" />
          <span>{sourceLabel}</span>
        </div>
      </div>
      <h2 className="text-lg md:text-xl font-bold mb-2 text-foreground">{question}</h2>
      <p className="text-sm md:text-base text-muted-foreground leading-relaxed font-medium border-l-2 border-accent pl-3">
        {answer}
      </p>
    </div>
  );
};

export default AEOAnswerBlock;
